import { render } from "./views/ModulePayment.html?vue&type=template&id=039773ba&external"
import script from "./ModulePayment.vue?vue&type=script&lang=js"
export * from "./ModulePayment.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__